import PropTypes from 'prop-types';
import React, { PureComponent, Fragment } from 'react';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles'
import style from './SchoolProgramInfoK.scss';
import SchoolDataSimple from '../SchoolDataSimple';
import { saveApplication } from '../../actions/saveApplication';
import { saveProgram } from '../../actions/saveProgram';
import messages from '../../locale/messages';
import analytics from '../../services/analytics';
import { isPK, is2K, is3K, isK, customisedIntlFormatMessage } from '../../utils/helpers';

const localMessages = defineMessages({
  preferencesTitle: {
    id: 'schoolprograminfo.preferences.title',
    defaultMessage: 'Preference is given to the following students',
    description: 'which students preference is given to',
  },
  kindergartenChances: {
    id: 'schoolprograminfok.chances',
    defaultMessage:
      'Your chances of an offer are a combination of your priority group for this program and its offers last year. Some programs have additional admissions considerations — see above.',
    description: 'which students preference is given to',
  },
});

class SchoolProgramInfoK extends PureComponent {
  static defaultProps = {
    description: '',
    eligible: null,
    interest_area_name: null,
  };
  static propTypes = {
    admissionMethod: PropTypes.shape({
      name: PropTypes.string,
      description: PropTypes.string,
    }).isRequired,
    description: PropTypes.string,
    demand_last_year: PropTypes.shape({
      general_education: PropTypes.shape({
        applications_per_seat: PropTypes.number,
        seats: PropTypes.number,
        applicants: PropTypes.number,
        seats_description: PropTypes.string,
        all_seats_filled: PropTypes.bool,
      }),
      students_with_disabilities: PropTypes.shape({
        applications_per_seat: PropTypes.number,
        seats: PropTypes.number,
        applicants: PropTypes.number,
        seats_description: PropTypes.string,
        all_seats_filled: PropTypes.bool,
      }),
      specialized_education: PropTypes.shape({
        applications_per_seat: PropTypes.number,
        seats: PropTypes.number,
        applicants: PropTypes.number,
        all_seats_filled: PropTypes.bool,
      }),
    }).isRequired,
    eligibility_description: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    getPriorityGroups: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    likelihood: PropTypes.string.isRequired,
    loggedIn: PropTypes.bool.isRequired,
    lowest_priority: PropTypes.string.isRequired,
    performance: PropTypes.string.isRequired,
    preference: PropTypes.string.isRequired,
    program: PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
    saveProgram: PropTypes.func.isRequired,
    saved: PropTypes.bool.isRequired,
    // savedProgramId: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
    savedApplication: PropTypes.bool.isRequired,
    saveApplication: PropTypes.func.isRequired,
    selection_criteria: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
      }),
    ).isRequired,
    selection_criteria_note: PropTypes.string.isRequired,
    school: PropTypes.shape({
      name: PropTypes.string,
      dbn: PropTypes.string,
    }).isRequired,
    schoolId: PropTypes.number.isRequired,
    user: PropTypes.shape({
      applicationId: PropTypes.string.isRequired,
    }).isRequired,
    intl: PropTypes.shape().isRequired,
    program_priority_groups: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
      }),
    ).isRequired,
    interest_area_name: PropTypes.string,
    eligible: PropTypes.bool,
  };

  accordionClick = accordionLabel => {
    const { school, program, loggedIn } = this.props;
    const { code, name } = program;
    let dataDictionary = {
      accordionLabel: accordionLabel,
      programName: `${name}`,
      programCode: `${code}`,
      schoolName: `${school.name}`,
      schoolDbn: `${school.dbn}`,
      loggedIn: loggedIn ? true : false
    };
    if(this.props.user.show_loo_tooltip){
      const { loo_chances } = this.props;
      dataDictionary['looIndicator'] = loo_chances || 'NOT_AVAIL_PROB';
    }
    analytics({
      eventLabel: 'programAccordionOpen',
      dataDictionary: dataDictionary
    });
  };

  assumeIndefiniteArticle = name => {
    const vowels = 'aeiou';

    if (vowels.indexOf(name[0]) > -1) return `an ${name}`;
    return `a ${name}`;
  };

  renderPriorityGroup = () => {
    const { getPriorityGroups, admissionMethod, preference } = this.props;
    const isLimitedUnscreened = admissionMethod.name === 'Limited Unscreened';
    const { all } = getPriorityGroups();

    if (!all || (all.filter(priority => priority.name).length === 0 && !preference)) {
      return null;
    } else if (!all || all.filter(priority => priority.name).length === 0) {
      return <div className={style.priorityGroups}>{this.renderPreference()}</div>;
    }

    const priorityGroups = all.map(priority => (
      <li className={style.priorityGroupListItem} key={`priority-accordion-${priority.id}`}>
        <div>{priority.name}</div>
        {priority.ge_priority_group_description && <div>({priority.ge_priority_group_description})</div>}
      </li>
    ));
    return (
      <div className={style.priorityGroups}>
        <div className={style.priorityGroupsHeader}>
          <FormattedMessage {...messages.generalStringPriorityGroup} tagName={'span'} />
        </div>
        {isLimitedUnscreened && (
          <div className={style.limitedUnscreenedMessage}>
            <FormattedMessage {...messages.schoolProgramLimitedUnscreened} />
          </div>
        )}
        <ol className={style.priorityGroupsList}>{priorityGroups}</ol>
        {this.props.lowest_priority && <p className={style.admissionsProcessText}>{this.props.lowest_priority}</p>}
        {this.renderPreference()}
      </div>
    );
  };

  renderPreference = () => {
    const { preference } = this.props;
    if (preference) {
      return (
        <Fragment>
          <div className={style.priorityGroupsHeader}>
            <FormattedMessage {...localMessages.preferencesTitle} />
          </div>
          <div>
            <p className={style.admissionsProcessText}>{this.props.preference}</p>
          </div>
        </Fragment>
      );
    }

    return null;
  };

  renderProgramPriorityGroups = () => {
    const programPriorityGroups = this.props.program_priority_groups;
    const { preference } = this.props;
    if (
      !programPriorityGroups ||
      (programPriorityGroups.filter(priority => priority.name).length === 0 && !preference)
    ) {
      return null;
    } else if (!programPriorityGroups || programPriorityGroups.filter(priority => priority.name).length === 0) {
      return <div className={style.priorityGroups}>{this.renderPreference()}</div>;
    }
    const priorityGroups = programPriorityGroups.map(priority => (
      <li key={`priority-accordion-${priority.id}`}>
        <div>{priority.name}</div>
        {priority.ge_priority_group_description && <div>({priority.ge_priority_group_description})</div>}
      </li>
    ));
    return (
      <div className={style.priorityGroups}>
        <div className={style.priorityGroupsHeader}>
          <FormattedMessage {...messages.generalStringPriorityGroup}  tagName={'span'} />
        </div>
        <ol className={style.priorityGroupsList}>{priorityGroups}</ol>
        {this.props.lowest_priority && <p className={style.admissionsProcessText}>{this.props.lowest_priority}</p>}
        {this.renderPreference()}
      </div>
    );
  };

  renderDemand = (demand, type) => {
    let allSeats;
    if (demand.all_seats_filled === false) {
      allSeats = <FormattedMessage {...messages.generalStringNotAllSeatsFilled} />;
    } else if (demand.all_seats_filled === true) {
      allSeats = <FormattedMessage {...messages.generalStringAllSeatsFilled} />;
    }
    return (
      <div className={style.demand}>
        <div className={style.demandBody}>
          {demand.applications_per_seat && (
            <div className={style.demandItemFirst}>
              <span className={style.demandRowOne}>{demand.applications_per_seat}</span>
              <span className={style.demandRowTwo}>
                <FormattedMessage {...messages.generalStringApplicationsPerSeat} />
              </span>
            </div>
          )}
          {demand.seats && (
            <div className={style.demandItem}>
              <span className={style.demandRowOne}>{demand.seats}</span>
              <span className={style.demandRowTwo}>
                <FormattedMessage {...messages.generalStringSeats} />
              </span>
            </div>
          )}
          {demand.applicants && (
            <div className={style.demandItem}>
              <span className={style.demandRowOne}>{demand.applicants}</span>
              <span className={style.demandRowTwo}>
                <FormattedMessage {...messages.generalStringApplicants} />
              </span>
            </div>
          )}
          {demand.seats_description && (
            <div className={style.demandItem}>
              <span className={style.demandRowTwo}>{demand.seats_description}</span>
            </div>
          )}
          <div className={style.demandItem}>
            <span className={style.demandRowTwo}>{allSeats}</span>
          </div>
        </div>
      </div>
    );;
  };

  renderSelectionCriteria = () => {
    const selectionCriteriaList = this.props.selection_criteria;
    const { name, name_en } = this.props.admissionMethod;
    const note = this.props.selection_criteria_note;
    if (!selectionCriteriaList.length) {
      return null;
    }

    const selectionCriteria = selectionCriteriaList.map(indCriteria => (
      <li className={style.selectionCriteriaListItem} key={`${indCriteria.name}-accordion`}>
        {indCriteria.name}
      </li>
    ));
    return (
      <div className={style.selectionCriteria}>
        <div className={style.selectionCriteriaHeader}>
          <FormattedMessage {...messages.generalStringSelectionCriteria} />
        </div>
        <div className={style.selectionCriteriaDescription}>
        {
          name == 'Screened With Assessment' || name_en == 'Screened With Assessment' ?
            <FormattedMessage {...messages.schoolProgramSelectionCriteriaDescription1} /> :
            <FormattedMessage
              {...messages.schoolProgramSelectionCriteriaDescription}
              values={{ name: this.assumeIndefiniteArticle(name.toLowerCase()) }}
            />
        }
        </div>
        <ul className={style.selectionCriteriaList}>{selectionCriteria}</ul>
        {note && <div className={style.selectionCriteriaNote}>{note}</div>}
      </div>
    );
  };

  render() {
    const { loggedIn, program, admissionMethod, eligible, firstName, intl, user, admissionProcess } = this.props;
    const isGT = program.admission_process ==='Gifted & Talented';
    const is2KProcess = is2K({ user }) || program.admission_process === '2K' || admissionProcess === '2K';
    const generalEducation = this.props.demand_last_year.general_education;
    const studentsWithDisabilities = this.props.demand_last_year.students_with_disabilities;
    const specializedEducation = this.props.demand_last_year.specialized_education;
    let renderDemandGE = true;
    let renderDemandSWD = true;
    let renderDemandSHS = true;
    let renderDescription = false;
    if (generalEducation && generalEducation.seats_description) {
      renderDescription = true;
    }
    if (
      generalEducation &&
      !generalEducation.applications_per_seat &&
      !generalEducation.seats &&
      !generalEducation.applicants &&
      ((!generalEducation.seats_description && !renderDescription) ||
        (generalEducation.seats_description && renderDescription)) &&
      !generalEducation.all_seats_filled
    ) {
      renderDemandGE = false;
    }
    if (
      studentsWithDisabilities &&
      !studentsWithDisabilities.applications_per_seat &&
      !studentsWithDisabilities.seats &&
      !studentsWithDisabilities.applicants &&
      !studentsWithDisabilities.seats_description &&
      !studentsWithDisabilities.all_seats_filled
    ) {
      renderDemandSWD = false;
    }
    if (
      specializedEducation &&
      !specializedEducation.applications_per_seat &&
      !specializedEducation.seats &&
      !specializedEducation.applicants &&
      !specializedEducation.all_seats_filled
    ) {
      renderDemandSHS = false;
    }
    let renderDemandSection = false;
    if (!is2KProcess && (!isGT || (!user.isK && (renderDemandGE || renderDemandSWD || renderDemandSHS || renderDescription)))) {
      renderDemandSection = true;
    }

    // eslint-disable-next-line no-unused-vars
    let showOtherFetures = false;
    if (isPK({ user }) || is2K({ user }) || is3K({ user }) || isK({ user })) {
      showOtherFetures = true;
    }
    return (
      <div className={style.accordionContainer}>
        {this.props.eligibility_description && !loggedIn && (
          <Fragment>
            <div className={style.sectionTitle}>
              <FormattedMessage {...messages.generalStringEligibilityDescription} />
            </div>
            <div className={style.programDataWrapper}>
              <p>{this.props.eligibility_description}</p>
            </div>
          </Fragment>
        )}

        <Fragment>
        <div className={style.flexContainer}>
            {renderDemandSection && (
              <>
                {!isGT && (<div className={style.demandHeader}>
                  <FormattedMessage {...messages.generalStringDemandLastYear} />
                </div>)}
                {(!loggedIn && renderDescription) && this.renderDemand(generalEducation, null)}
                {renderDemandGE && (
                  <div>
                    {this.renderDemand(
                      generalEducation,
                      customisedIntlFormatMessage(intl, messages.generalStringGeneralEducation),
                    )}
                  </div>
                )}
                {renderDemandSWD && (
                  <div>
                    {this.renderDemand(
                      studentsWithDisabilities,
                      customisedIntlFormatMessage(intl, messages.generalStringStudentsWithDisabilities),
                    )}
                  </div>
                )}
                {renderDemandSHS && <div>{this.renderDemand(specializedEducation)}</div>}
              </>
            )}
          </div>
        </Fragment>

        <Fragment>
          <div className={style.sectionTitle}>
            <FormattedMessage {...messages.generalStringAdmissionsMethod} />
          </div>
          <div className={style.programDataWrapper}>
            <div>
              <div className={style.programDataWrapper}>
                <p>{admissionMethod.name}</p>
              </div>
            </div>
          </div>
        </Fragment>
        <Fragment>
          <div className={style.sectionTitle}>
            <FormattedMessage {...messages.generalStringMyChances} />
          </div>
          <div className={style.programDataWrapper}>
            {this.props.eligibility_description && (
              <Fragment>
                <div className={style.demandHeader}>
                  <FormattedMessage {...messages.generalStringEligibility} />
                </div>
                {loggedIn && !eligible && (
                  <div>
                    <strong>
                      <FormattedMessage
                        {...messages.generalStringStudentNotEligibleForProgram}
                        values={{ firstName }}
                      />
                    </strong>
                  </div>
                )}
                <p>{this.props.eligibility_description}</p>
              </Fragment>
            )}
            {!this.props.eligibility_description && (
              <p>
                <FormattedMessage {...localMessages.kindergartenChances} />
              </p>
            )}
            <div className={style.flexContainer}>{this.renderProgramPriorityGroups()}</div>
            {this.renderSelectionCriteria()}
          </div>
        </Fragment>
        {program.code && (
          <Fragment>
            <div className={style.sectionTitle}>
              <FormattedMessage {...messages.generalStringAdditionalInformation} />
            </div>
            <div className={style.programDataWrapper}>
              <SchoolDataSimple title={customisedIntlFormatMessage(intl, messages.generalStringProgramCode)} stat={program.code} />
            </div>
          </Fragment>
        )}
      </div>
    );
  }
}

const mapState = ({ user }) => ({ user });
const mapDispatch = {
  saveProgram,
  saveApplication,
};

export { SchoolProgramInfoK };
export default injectIntl(
  connect(
    mapState,
    mapDispatch,
  )(withStyles(style)(SchoolProgramInfoK)),
);
